import actions from "./app.actions";

export const initialState = {
  isMapPage: false,
  isDailyRentPage: false,
  msgsCount: 0,
  chartJSLoaded: false,
};

export default function appReducer(state, action) {
  if (action.type === actions.SET_IS_MAP_PAGE) {
    return {
      ...state,
      isMapPage: action.payload,
    };
  }
  if (action.type === actions.SET_IS_DAILY_RENT_PAGE) {
    return {
      ...state,
      isDailyRentPage: action.payload,
    };
  }
  if (action.type === actions.SET_NEW_MSGS_COUNT) {
    return {
      ...state,
      msgsCount: action.payload,
    };
  }
  if (action.type === actions.SET_CHART_JS_LOADED) {
    return {
      ...state,
      chartJSLoaded: action.payload,
    };
  }
  return state;
}
